(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

require('./auth.js');

},{"./auth.js":2}],2:[function(require,module,exports){
"use strict";

//https://developer.mozilla.org/en-US/docs/Web/Events/scroll
;(function () {
    var throttle = function throttle(type, name, obj) {
        obj = obj || window;
        var running = false;
        var func = function func() {
            if (running) {
                return;
            }
            running = true;
            requestAnimationFrame(function () {
                obj.dispatchEvent(new CustomEvent(name));
                running = false;
            });
        };
        obj.addEventListener(type, func);
    };

    /* init - you can init any event */
    throttle("scroll", "optimizedScroll");
})();

var easeInOutQuad = function easeInOutQuad(x, t, b, c, d) {
    if ((t /= d / 2) < 1) return c / 2 * t * t + b;
    return -c / 2 * (--t * (t - 2) - 1) + b;
};

var generateHeaderPath = function generateHeaderPath(x0, x1, x2, x3, y0, y1, y2, r) {
    r = Math.min((x2 - x1) / 2 - 1, (y2 - y1) / 2 - 1, r);
    var a = (y2 - y1) / (x2 - x1 - 2 * r);
    var xr = r / Math.sqrt(a * a + 1);
    var yr = a * xr;
    return "<path class=\"path\" d=\"\n            M " + x0 + " " + y1 + " H " + x1 + "\n            C " + (x1 + r) + " " + y1 + ", " + (x1 + r) + " " + y1 + ", " + (x1 + r + xr) + " " + (y1 + yr) + "\n            L " + (x2 - r - xr) + " " + (y2 - yr) + "\n            C " + (x2 - r) + " " + y2 + ", " + (x2 - r) + " " + y2 + ", " + x2 + " " + y2 + " H " + x3 + "\n        \"></path>\n        <path class=\"fill\" d=\"\n            M " + x0 + " " + y0 + " V " + y1 + " H " + x1 + "\n            C " + (x1 + r) + " " + y1 + ", " + (x1 + r) + " " + y1 + ", " + (x1 + r + xr) + " " + (y1 + yr) + "\n            L " + (x2 - r - xr) + " " + (y2 - yr) + "\n            C " + (x2 - r) + " " + y2 + ", " + (x2 - r) + " " + y2 + ", " + x2 + " " + y2 + " H " + x3 + "\n            V " + y0 + " Z\n        \"></path>\n        ";
};

var drawHeaderBorder = function drawHeaderBorder(headerHeight, authHeight, authWidth, percentage) {
    var headerBorder = $('.header__border');
    var x3 = headerBorder.width();
    var x2 = x3 - authWidth + 5;
    var x1 = x2 - Math.max(170 * percentage, 100);
    var y1 = headerHeight;
    var y2 = Math.max(headerHeight, authHeight);
    var svg = document.getElementById('authborder_svg');
    svg.setAttribute('width', x3);
    svg.setAttribute('height', y2 + 1);
    svg.innerHTML = generateHeaderPath(0, x1, x2, x3, 0, y1, y2, 40);
};

var unfoldAuth = function unfoldAuth() {
    $('.auth').removeClass('auth-folded');
};

var foldAuth = function foldAuth() {
    $('.auth').addClass('auth-folded');
    $('.auth').css('height', 'auto');
    $('.auth__lightbox').css('top', 0);
};

var drawAuth = function drawAuth(percentage, height) {
    if (percentage <= 0.00001) {
        foldAuth();
        return;
    }
    unfoldAuth();
    $('.auth').height(height);
    var textHeight = $('.auth__text').outerHeight() + 15;
    $('.auth__lightbox').css('top', (1 - percentage) * (-initialHeight + textHeight));
    $('.auth__text, .auth__email-input, .auth__password-input').css('opacity', percentage);
};

var drawHeader = function drawHeader(percentage) {
    percentage = Math.min(Math.max(percentage, 0), 1);
    var headerHeight = $('.header__container').outerHeight();
    var authHeight = initialHeight * percentage + (isMobile() ? 0 : headerHeight);
    var authWidth = $('.auth').width();
    drawHeaderBorder(headerHeight, authHeight, authWidth, percentage);
    drawAuth(percentage, authHeight);
};

var animationTime = 500;
function startAnimation(fromPos, toPos) {
    if (fromPos === toPos) {
        return 0;
    }
    var start = void 0;

    var T = Math.abs(toPos - fromPos) * animationTime;
    var revert = toPos < fromPos;
    function animation(timestamp) {
        start = start || timestamp;
        var t = timestamp - start;
        var t = Math.min(t, T);
        var p = easeInOutQuad(null, t, fromPos, toPos - fromPos, T);
        drawHeader(p);
        if (t < T) {
            window.requestAnimationFrame(animation);
        }
    }

    window.requestAnimationFrame(animation);
    return animationTime;
}

var isMobile = function isMobile() {
    return $(window).width() <= 850;
};
var isFolded = function isFolded() {
    return $('.auth').hasClass('auth-folded');
};

var initialHeight = $('.auth').outerHeight() - (isMobile() ? 0 : $('.header__container').outerHeight());
var currentPercentage = function currentPercentage() {
    return isMobile() ? 0 : easeInOutQuad(null, Math.max(0, 1 - $(window).scrollTop() / initialHeight), 0, 1, 1);
};

var isDisplayed = false;
var isLocked = false;
var displayAuth = function displayAuth() {
    var locked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    !isDisplayed && startAnimation(0, 1);
    isDisplayed = true;
    isLocked = locked;
};

var hideAuth = function hideAuth() {
    var unlock = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    if (!isLocked || unlock === true) {
        isDisplayed && startAnimation(1, 0);
        isDisplayed = false;
        isLocked = !unlock;
    }
};

function init() {
    if (!isMobile()) {
        displayAuth();
    } else {
        foldAuth();
    }

    if ($('.auth').hasClass('auth-has-error')) {
        drawHeader(1);
        isDisplayed = true;
    }

    $('.auth').submit(function (event) {
        if (isFolded()) {
            displayAuth(true);
            event.preventDefault();
            return;
        }

        $('.auth__connect-btn').addClass('auth__connect-btn-connecting hover');
    });

    if (isMobile()) {
        $('.auth__email-input').focus(function () {
            $('.auth__drawing').css('display', 'none');
            $('.auth__lightbox').css('justify-content', 'flex-start');
        });
    }

    window.addEventListener('optimizedScroll', function () {
        return currentPercentage() > 0.94 ? displayAuth() : hideAuth();
    });
    window.onresize = hideAuth;
    window.clickCloseBtn = function () {
        return hideAuth(true);
    };
    $('.auth').removeClass('auth-init');
}

setTimeout(init, 0);

},{}]},{},[1]);
